// === FILE: assets/italiansecret-cart-stock-main.js ===
// Orchestrator: runs stock validation and triggers widget refresh

import { IS_LOG_PREFIX } from "./italiansecret-cart-stock-utils.js";
import { validateInventory } from "./italiansecret-cart-stock-core.js";

document.addEventListener("DOMContentLoaded", () => {
  if (window.IS_STOCK_GUARD_ENABLED === false) {
    console.log(`${IS_LOG_PREFIX} – Disabled via config`);
    return;
  }
  console.log(`${IS_LOG_PREFIX} – Main initialized`);

  const form = document.querySelector("form[action='/cart'], form[action*='/cart']");
  if (!form) return;

  // ✅ Check before checkout submit
  form.addEventListener("submit", async e => {
    const shortages = await validateInventory();
    if (shortages.length) {
      e.preventDefault();
      window.ISStockWidget?.refresh();
      console.warn(`${IS_LOG_PREFIX} – Checkout blocked due to shortages`);
    }
  });

  // ✅ Refresh when quantity changes
  document.querySelectorAll(".qty, input[name='updates[]']").forEach(i => {
    i.addEventListener("change", () => {
      window.ISStockWidget?.refresh();
    });
  });

  // ✅ Refresh also when cart updates via AJAX
  document.addEventListener("cart:updated", () => {
    window.ISStockWidget?.refresh();
  });

  // ✅ Initial run
  window.ISStockWidget?.refresh();

  console.log(`${IS_LOG_PREFIX} – Ready ✅`);
});
